import { render, staticRenderFns } from "./editPolicyBrokerModal.vue?vue&type=template&id=57ef6c1d&scoped=true&"
import script from "./editPolicyBrokerModal.vue?vue&type=script&lang=js&"
export * from "./editPolicyBrokerModal.vue?vue&type=script&lang=js&"
import style0 from "./editPolicyBrokerModal.vue?vue&type=style&index=0&id=57ef6c1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ef6c1d",
  null
  
)

export default component.exports